let elems = document.querySelectorAll('a[data-gtm]');
Array.prototype.forEach.call( elems, function( el ) {
  el.addEventListener( 'click', function( ev ) {
    let data = ( ev.target || ev.srcElement ).dataset.gtm;
    if ( data ) {
      ( window.dataLayer || [] ).push({ event: data });
    }
  });
});

export default undefined;
